const s3ImagesRootBeta = "https://account-files-bucket.s3.ap-south-1.amazonaws.com/universe/assets/";
const s3ImagesRootLive = "https://account-files-bucket.s3.ap-south-1.amazonaws.com/universe/assets/";

export const makeFullS3ObjectUrl = (imageName: string): string => {
  return `${process.env.REACT_APP_ENV === "PRODUCTION" ? s3ImagesRootLive : s3ImagesRootBeta}${imageName}`;
};
